import { Link } from "react-router-dom";
import { Mail, ShieldCheck } from "lucide-react";
import { LOGO, CONTACT_EMAIL } from "../lib/constants";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0A1128] text-[#C4C8CC]">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-5 gap-12">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-5">
          <img src={LOGO} alt="Fiscoconseils" className="h-12 w-12 object-contain bg-white rounded-full p-1" loading="lazy" width="48" height="48" />
          <span className="font-heading text-2xl font-semibold text-white">Fiscoconseils</span>
        </div>
        <p className="text-sm leading-relaxed max-w-md text-[#9CA3AF]">
          L'expertise fiscale au service des frontaliers, particuliers et entreprises suisses.
          Déclarations fiscales suisses et françaises, rectifications, optimisations et démarches administratives.
        </p>
        <p className="text-xs leading-relaxed max-w-md text-[#6B7280] mt-4">
          Fiscaliste frontalier Genève, Annemasse, Saint-Julien-en-Genevois, Pays de Gex et Haute-Savoie. Conseiller fiscal France-Suisse, 100 % en ligne.
        </p>
        <div className="flex items-center gap-2 mt-5 text-sm">
          <Mail size={15} strokeWidth={1.75} />
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="hover:text-white transition-colors duration-200">{CONTACT_EMAIL}</a>
        </div>
      </div>
      <div>
        <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#6B7280] mb-5">Navigation</h4>
        <ul className="space-y-3 text-sm">
          <li><Link to="/services" className="hover:text-white transition-colors duration-200">Services</Link></li>
          <li><Link to="/frontaliers" className="hover:text-white transition-colors duration-200">Frontaliers Suisse-France</Link></li>
          <li><Link to="/independants-entreprises" className="hover:text-white transition-colors duration-200">Indépendants & Entreprises</Link></li>
          <li><Link to="/devis" className="hover:text-white transition-colors duration-200">Demander un devis</Link></li>
          <li><Link to="/faq" className="hover:text-white transition-colors duration-200">FAQ</Link></li>
          <li><Link to="/espace-client" data-testid="footer-client-link" className="hover:text-white transition-colors duration-200">Espace client</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#6B7280] mb-5">Guides frontaliers</h4>
        <ul className="space-y-3 text-sm">
          <li><Link to="/declaration-impots-frontalier-suisse" data-testid="footer-guide-pillar" className="hover:text-white transition-colors duration-200">Déclaration impôt frontalier Suisse</Link></li>
          <li><Link to="/declaration-impots-frontalier-geneve" className="hover:text-white transition-colors duration-200">Déclaration frontalier Genève</Link></li>
          <li><Link to="/tou-geneve" className="hover:text-white transition-colors duration-200">TOU Genève</Link></li>
          <li><Link to="/quasi-resident-geneve" className="hover:text-white transition-colors duration-200">Quasi-résident Genève</Link></li>
          <li><Link to="/rectification-impot-source-geneve" className="hover:text-white transition-colors duration-200">DRIS / rectification impôt source</Link></li>
          <li><Link to="/formulaire-2047-suisse" className="hover:text-white transition-colors duration-200">Formulaire 2047 Suisse</Link></li>
          <li><Link to="/guides-fiscaux-frontaliers" className="hover:text-white transition-colors duration-200 font-semibold">Tous les guides →</Link></li>
          <li><Link to="/outils-frontaliers" className="hover:text-white transition-colors duration-200 font-semibold">Outils gratuits →</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#6B7280] mb-5">Légal</h4>
        <ul className="space-y-3 text-sm">
          <li><Link to="/politique-de-confidentialite" data-testid="footer-privacy-link" className="hover:text-white transition-colors duration-200">Politique de confidentialité</Link></li>
          <li><Link to="/mentions-legales" className="hover:text-white transition-colors duration-200">Mentions légales</Link></li>
          <li><Link to="/conditions-generales" className="hover:text-white transition-colors duration-200">Conditions générales</Link></li>
          <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white transition-colors duration-200">Espace administrateur</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#6B7280]">
        <p>© {new Date().getFullYear()} Fiscoconseils. Tous droits réservés.</p>
        <p className="flex items-center gap-2"><ShieldCheck size={14} strokeWidth={1.75} /> Confidentialité et sécurité des données garanties</p>
      </div>
    </div>
  </footer>
);
